/// <amd-module name="TFS/Samples/MasterDetails/LayerComponents/PullRequest/PullRequestDetailsContent" />
import * as React from "react";
import { useComponentContext } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { Header } from "VSSUI/Header";
import { MasterDetailsContext } from "VSSUI/MasterDetailsContext";
import { Page } from "VSSUI/Page";
import { ITableColumn, ITableRow, SimpleTableCell, Table } from "VSSUI/Table";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { ICommit, IPullRequest } from "../../SampleData";
import { getCommitLayer } from "../Commit/CommitLayer";

const tableColumns: ITableColumn<ICommit>[] = [
    {
        id: "description",
        name: "Description",
        width: -33,
        renderCell: (rowIndex, colIndex, tableColumn, tableItem) => (
            <SimpleTableCell key={tableItem.hashCode + colIndex} columnIndex={colIndex} tableColumn={tableColumn}>
                {tableItem.description}
            </SimpleTableCell>
        )
    }
];

export const PullRequestDetailsContent: React.FunctionComponent<{
    pullRequest: IPullRequest;
}> = props => {
    const { pullRequest } = props;

    const commitItemProvider = new ArrayItemProvider(pullRequest.commits);
    const masterDetailsContext = React.useContext(MasterDetailsContext);
    const pageContext = useComponentContext().pageContext;

    const onCommitSelected = (event: any, tableRow: ITableRow<ICommit>) => {
        masterDetailsContext.push(getCommitLayer(tableRow.data, pullRequest, pageContext));
    };

    return (
        <Page className="flex-grow">
            <Header title={pullRequest.title} description={pullRequest.hashCode} />
            <div className="page-content page-content-top">
                <Card className="flex-grow bolt-card-no-vertical-padding" contentProps={{ contentPadding: false }}>
                    <Table
                        columns={tableColumns}
                        itemProvider={commitItemProvider}
                        showLines={true}
                        singleClickActivation={true}
                        onActivate={onCommitSelected}
                    />
                </Card>
            </div>
        </Page>
    );
};
